<template>
  <div id="aset-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
    <vs-sidebar class="items-no-padding" parent="#aset-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarFilterActive">

        <component :is="scrollbarTag" class="aset-scroll-area" :settings="settings" :key="$vs.rtl">
            <aset-filters @closeSidebar="toggleFilterSidebar"
            :asetFilter="asetFilter"
            :Search="search"
            :maxRange="asetMaxRange"></aset-filters>
        </component>
    </vs-sidebar>

    <div :class="{'sidebar-spacer': clickNotClose}"  id="aset-load" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content vs-con-loading__container">

      <div class="d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light py-2">
        <!--  class="flex items-center" -->
        <div class="vx-row px-2">
          <div class="vx-col w-3/4 items-center">
            <div>
              <!-- TOGGLE SIDEBAR BUTTON -->
              <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleFilterSidebar(true)" />

              <!-- SEARCH BAR -->
              <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" placeholder="Search..." v-model="search" v-on:keyup.enter="filterData()" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
            </div>
          </div>
          <div class="vx-col w-1/4 flex items-center justify-end">
            <div class="dropdown-button-container">
              <vs-button class="btnx" type="border" size="">Page</vs-button>

              <vs-dropdown>
                <vs-button class="btn-drop py-4" type="filled" icon="expand_more" size=""></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="p in asetPage" :key="p" @click.stop="nextData(p)" :disabled="p === asetCurrentPage">
                    {{ p }}
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center flex-wrap justify-between md:px-8 px-4">
      </div>

      <!-- ASET LIST -->
      <component :is="scrollbarTag" id="aset-load" class="aset-content-scroll-area" :settings="settings" ref="asetListPS" :key="$vs.rtl">

          <transition-group name="list-enter-up" tag="ul" appear>
            <li
              class="cursor-pointer"
              v-for="(aset, index) in asetList"
              :key="String(index) + String(aset.id)"
              :style="[{transitionDelay: (index * 0.1) + 's'}]"
              @click="viewAkumulasiSidebar(aset)">
              <aset-item :data="aset" />
            </li>
          </transition-group>
      </component>
      <!-- /ASET LIST -->
    </div>


    <aset-akumulasi 
    :isAkumulasiActive="isAkumulasiActive"
    @closeAkumulasi="closeAkumulasiSidebar"
    :data="dataAset"
    ></aset-akumulasi>

  </div>
</template>

<script>
import moduleAset from '@/stores/accounting/aset/moduleAset.js'
import AsetItem            from './AsetItem.vue'
import AsetAkumulasi       from './AsetAkumulasi.vue'
import AsetFilters         from './AsetFilters.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr          from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    AsetItem,
    AsetAkumulasi,
    AsetFilters,
    VuePerfectScrollbar,
    flatPickr
  },
  data () {
    return {
      dataAset : {},
      isAkumulasiActive : false,
      currFilter : '',
      clickNotClose : true,
      displayPrompt : false,
      isSidebarFilterActive : true,

      settings : {
        maxScrollbarLength : 60,
        wheelSpeed : 0.30
      },

      // Param
      search: '',
      mulai: null,
      sampai: null,
    }
  },
  watch: {
    '$route' (to, from) {
      if (from.params.taxonomy != to.params.taxonomy) {
        this.loadData()
      }
    },
    isAkumulasiActive (value) {
      if (!value) this.showThread = false
    },
    asetFilter () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#aset-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.asetListPS.$el || this.$refs.asetListPS
      scroll_el.scrollTop = 0
      this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
      const obj = {
        taxonomy: this.$route.params.taxonomy,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.aset.state_range
      }
      this.$store.commit('aset/SET_NULL_TASKS')
      this.$store.dispatch('aset/fetchAset', obj)
      if (this.$store.state.aset.asets.length > 0 || this.$store.state.aset.asets.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#aset-load > .con-vs-loading')
        }, 2000)
      }
      this.toggleFilterSidebar()
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    asetFilter ()   { return this.$route.params.filter },
    asetList ()     { return this.$store.state.aset.asets      },
    asetTags () {
      return this.$store.state.aset.asetTags
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    windowWidth ()  { return this.$store.state.windowWidth },
    asetTotal () {
      return this.$store.state.aset.total_page
    },
    asetTotalSatu () {
      return this.$store.state.aset.total_page + 1
    },
    asetLast () {
      return this.$store.state.aset.last
    },
    asetPerPage () {
      return this.$store.state.aset.per_page
    },
    asetCurrentPage () {
      return this.$store.state.aset.current_page
    },
    asetPage () {
      const page = []
      const number = this.$store.state.aset.total_page / this.$store.state.aset.per_page
      var i
      for (i=0; i < number; i++) {
        page.push(i+1)
      }
      return page
    },
    asetTotalPage () {
      let number = this.$store.state.aset.total_page / this.$store.state.aset.per_page
      if (number < 1) {
        number = 1
      }
      return number.toFixed(0)
    },
    asetMaxRange () {
      return this.$store.state.aset.max_range
    }
  },
  created () {
    this.$vs.loading()
    this.$store.registerModule('aset', moduleAset)
    this.setSidebarWidth()

    const obj = {
      taxonomy: this.$route.params.taxonomy,
      filter: this.$route.params.filter
    }
    // Fetch
    this.$store.dispatch('aset/fetchAset', obj)
    this.$store.dispatch('aset/fetchTag', this.$route.params.taxonomy)
    this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
    setTimeout(() => {
      this.$vs.loading.close()
    }, 3000)
  },
  beforeUpdate () {
    this.currFilter = this.$route.params.filter
  },
  beforeDestroy () {
    this.$store.unregisterModule('aset')
  },
  mounted () { 
  },
  methods: {
    loadData () {
      this.$vs.loading()
      const obj = {
        taxonomy: this.$route.params.taxonomy,
        filter: this.$route.params.filter
      }
      // Fetch
      this.$store.dispatch('aset/fetchAset', obj)
      this.$store.dispatch('aset/fetchTag', this.$route.params.taxonomy)
      this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
      setTimeout(() => {
        this.$vs.loading.close()
      }, 3000)
    },
    viewAkumulasiSidebar(data) {
      this.dataAset = data
      this.isAkumulasiActive = true
    },
    closeAkumulasiSidebar () {
      this.dataAset = {}
      this.isAkumulasiActive = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isSidebarFilterActive = this.clickNotClose = false
      } else {
        this.isSidebarFilterActive = this.clickNotClose = true
      }
    },
    toggleFilterSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarFilterActive = value
    },
    toggleAkumulasiSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarAkumulasiActive = value
    },
    nextData (page) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#aset-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.asetListPS.$el || this.$refs.asetListPS
      scroll_el.scrollTop = 0

      this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
      const obj = {
        taxonomy: this.$route.params.taxonomy,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.aset.state_range,
        page: page
      }
      this.$store.commit('aset/SET_NULL_TASKS')
      this.$store.dispatch('aset/fetchAset', obj)
      setTimeout(() => {
        this.$vs.loading.close('#aset-load > .con-vs-loading')
      }, 3000)
    },
    filterData (page) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#aset-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.asetListPS.$el || this.$refs.asetListPS
      scroll_el.scrollTop = 0

      this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
      const obj = {
        taxonomy: this.$route.params.taxonomy,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.aset.state_range,
        page: page
      }

      this.$store.commit('aset/SET_NULL_TASKS')
      this.$store.dispatch('aset/fetchAset', obj)
      if (this.$store.state.aset.asets.length > 0 || this.$store.state.aset.asets.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#aset-load > .con-vs-loading')
        }, 2000)
      }
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/aset.scss";
.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, .2);
  }
}
.total-slider {
  min-width: unset;
}
</style>
